import { render } from "./OngoingCourse.vue?vue&type=template&id=5e89c25e&scoped=true&ts=true"
import script from "./OngoingCourse.vue?vue&type=script&lang=ts"
export * from "./OngoingCourse.vue?vue&type=script&lang=ts"

import "./OngoingCourse.vue?vue&type=style&index=0&id=5e89c25e&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e89c25e"]])

export default __exports__